export default __webpack_public_path__ + "static/media/medica-logo.35d13ca2.jpg";